import React from 'react';

import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {useBuildContextNodeEditabilityElement} from "../../Hooks/GenericModelHooks";
import {ContextNodeLink} from "./ContextNodeViewer";
import {useFetchContextNode} from "../../Hooks/ContextHooks";

export const ContextNodeWithFullContextViewer = function (props) {

    const contextNode = useFetchContextNode(props.ContextNodeId, props.ContextNode);

    const context = ContextNodeService.GetSubtitle(contextNode);

    const buildContextNodeEditabilityElement = useBuildContextNodeEditabilityElement();
    const editability = buildContextNodeEditabilityElement(contextNode);

    return <div className="sb-context-node-viewer">
        <ContextNodeLink contextNode={contextNode}/>
        <div className="sb-autocomplete-subtext">{context}</div>
        {editability}
    </div>;
};
